module.exports = "https://coursera_assets.s3.amazonaws.com/images/9c1283efb3dd64dd1ded97f6deca09d5.png";